// Va subito dopo le lingue di moment. Ogni file di lingua, caricandosi, diventa la lingua
// predefinita: "locales.min.js" (tutte le 135 lingue, usato fino a ottobre 2026) alla fine
// rimetteva l'inglese, e il sito conta su quello. L'italiano si chiede caso per caso con
// .locale('it'), come fanno ko-date.js e i template degli orari.
moment.locale('en');
